<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size * 16 / 13"
    viewBox="0 0 13 16"
  >
    <g>
      <g>
        <path
          :fill="color"
          d="M10.721 13.415a.529.529 0 0 1-.528.528H2.585a.529.529 0 0 1-.528-.528V8.026c0-.291.237-.528.528-.528h7.608c.291 0 .528.237.528.528zm-6.13-9.146c0-.958.807-1.738 1.797-1.738.99 0 1.796.78 1.796 1.738V6.44H4.592zm4.65 2.172V4.269c0-1.541-1.28-2.794-2.853-2.794-1.573 0-2.853 1.253-2.853 2.794V6.44h-.95C1.711 6.441 1 7.152 1 8.026v5.389C1 14.289 1.711 15 2.585 15h7.608c.874 0 1.585-.711 1.585-1.585V8.026c0-.874-.711-1.585-1.585-1.585z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M6.389 9.03a.977.977 0 0 0-.53 1.799v1.16a.528.528 0 1 0 1.057 0V10.83a.976.976 0 0 0-.527-1.8z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#857A98',
    },
    size: {
      type: Number,
      default: 13,
    },
  },
};
</script>
